import Upsertable from '@/models/Upsertable'
import { useAgriProductStore } from '@/stores/agriProductStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriProduct extends Upsertable {
  static store() {
    return useAgriProductStore()
  }

  store() {
    return AgriProduct.store()
  }

  static find(uuid) {
    const obj = AgriProduct.store().find(uuid)
    let agri_product = new AgriProduct()
    return Object.assign(agri_product, obj)
  }
}

useModelName(AgriProduct, "AgriProduct")
ModelRegistry.register(AgriProduct, "AgriProduct")